import { createStore } from "zustand/vanilla";

/**
 * An admin support session (auth-tenancy.md, Platform admins). The admin app
 * opens staff web at `/support#r=<restaurantId>&t=<token>`; while the session
 * lasts, every call names that restaurant and carries the token as
 * `x-impersonation`. Held in memory; staff web keeps a copy in sessionStorage
 * so a reload in the same tab keeps it.
 */
export type SupportSession = { restaurantId: string; token: string };

export type SupportSessionState = {
	session: SupportSession | null;
	start(session: SupportSession): void;
	end(): void;
};

export function createSupportSessionStore(initial: SupportSession | null = null) {
	return createStore<SupportSessionState>((set) => ({
		session: initial,
		start: (session) => set({ session }),
		end: () => set({ session: null }),
	}));
}

export type SupportSessionStore = ReturnType<typeof createSupportSessionStore>;

/** Reads `r` and `t` from a `/support` URL fragment, or null. */
export function parseSupportFragment(hash: string): SupportSession | null {
	const params = new URLSearchParams(hash.replace(/^#/, ""));
	const restaurantId = params.get("r");
	const token = params.get("t");
	return restaurantId && token ? { restaurantId, token } : null;
}
